import React from "react";
import css from "./StartAppBlog.module.css";
import {BlogView,NoticeView,SectionView,TextView, Title} from "Components";


export default function StartAppBlog(props={}){
    const {}=props;
    //const envarnames=useRef(Object.keys(statics.envars)).current;
    return (
        <BlogView 
            className={css.startappblog} 
            sections={[
                {
                    title:"setting up the development environment",
                    text:`
                        In this guide, you will be taken step by step on how to start 
                        a vritra app using the <a href="https://cordova.apache.org/">Cordova</a> framework. 
                        @Prior to that, it is necessary to install certain packages :
                    `,
                    cli:{
                        lines:[
                            "#NPM","npm install -g cordova",
                            //"#YARN","yarn global add cordova",
                        ],
                    },
                    notice:"This guide assumes that you have already set up a <a href='https://nodejs.org/en/download'>Node.js</a> environment on your machine",
                },
            ]}
        >
            <SectionView 
                title="creating a new application"
                text={`
                    The create-vritra-app command will create a vritra-themed cordova project
                    preconfigured with the suitable plugins and packages to get you started.
                    @If you have <a href="https://git-scm.com/downloads">Git</a> installed then a new repository will be initialized.
                    @If <a href="https://code.visualstudio.com/download">VSCode</a> is installed, 
                    will open the app in a new vscode window.
                `}
                cli={{lines:["npx create-vritra-app MyNewApp"]}}
            >
                <div className={css.optionsection} title="options and flags">
                    {statics.cmdoptions.map(option=>(
                        <SectionView key={option.name} {...option} title={option.name}/>
                    ))}
                </div>
                <TextView text={`
                    in a typical cordova project, your HTML, CSS and JavaScript should be located in the <span>www</span> folder.
                    @in a <span>vritra</span> app, you no longer need to deal with that folder
                    anymore as all of your source code is going to be in the <span>src</span> folder, and
                    the <span>vritra-scripts</span> configuration will handle the content of the www folder for you.  
                `}/>
                <NoticeView text={`
                    the <span>create-vritra-app</span> npx command is currently targeting 
                    <span>cordova-android</span> version <b>10.1.2</b>
                    and <span>cordova-ios</span> version <b>7</b>, so make sure to use
                    equivalent platform versions
                    @other versions may work, but the app configuration and default plugins are tested on the specified versions.
                    @use the <b>--version</b> flag to check what versions the template targets
                `}/>
            </SectionView>
            <SectionView
                title="start the developement process"
                text="To start a development server, run the following command :"
                cli={{
                    lines:[
                        "#NPM","npm start",
                        //"#YARN","yarn start",
                    ],
                }}
            >
                <TextView>
                    The page will refresh when you make changes, 
                    and any lint errors will be displayed in the browser's console as well.
                </TextView>
                <NoticeView text={`
                    Adding browser platform to your project via <span>cordova platform add browser</span> command is required
                    @to build your app for 
                    <a href="https://cordova.apache.org/docs/en/12.x/guide/platforms/android/index.html">android</a> or 
                    <a href="https://cordova.apache.org/docs/en/12.x/guide/platforms/ios/index.html">iOS</a>, 
                    check the guides provided in the cordova website
                `}/>
            </SectionView>
        </BlogView>
    )
}

const statics={
    cmdoptions:[
        {
            name:"--packageName",
            text:"specifies the app package name, default to <b>com.appName.app</b>",
            cli:{lines:["npx create-vritra-app MyAppName --packageName=custom.package.name"]},
        },
        {
            name:"-v | --version",
            text:"shows the npx command version and the supported platforms",
            cli:{lines:["npx create-vritra-app --version"]},
        },
    ],
}
